<template>
<div id="enter-dedication">
    <div class="inputContainer">
        <p>Geben Sie einen persönlichen Grußtext ein, der auf der Rückseite anstatt der Zusammenfassung erscheint:</p>

        <multi-line-text-editor ref="multiLineText" :text="dedicationInternal" 
            :optional="optional" textAreaId="textarea-no-resize" textAreaWrapperClass="rv-enterGreetings" :createTextWithSize="true"
            :config="textCanvasConfig"
            @change="updateDedication" @changeInternal="updateInternalDedication"
            ></multi-line-text-editor>

    </div>

    <primary-buttons v-on:cancel="onCancel" v-on:confirm="onConfirm" :confirmable="confirmable"></primary-buttons>
</div>
</template>

<script>
import PrimaryButtons from "@/components/common/PrimaryButtons.vue"
import { AppModule } from '@/store/modules/app'
import { TreasureBookModule, BackDetailState } from '@/store/modules/treasureBook'
import MultiLineTextEditor from '@/components/common/MultiLineTextEditor.vue'
import { TextCanvasConfig } from '@/components/common/TextCanvas.vue'

export default {
    name: "enter-dedication",
    props: {
        optional: Boolean
    },
    data: function(){
        return {
            dedicationOriginal: "",
            userInputDedicationOriginal: "",
            mounted: false,
        }
    },
    created: function() {
        this.dedicationOriginal = TreasureBookModule.dedication
        this.userInputDedicationOriginal = TreasureBookModule.userInputDedication
    },
    mounted: function() {
        this.mounted = true
    },
    computed: {
        confirmable: function() {
            if(this.mounted) {
                return this.$refs.multiLineText.validate()
            }
            return false
        },
        dedicationInternal: function() {
            return TreasureBookModule.userInputDedication
        },
        textCanvasConfig: function() {
            return AppModule.textConfig
        }
    },
    methods: {
        onCancel: function() {
            TreasureBookModule.SetBackDetailState(BackDetailState.NONE)
            TreasureBookModule.SetDedication(this.dedicationOriginal)
            TreasureBookModule.SetUserInputDedication(this.userInputDedicationOriginal)
            this.$emit('cancel')
        },
        onConfirm: function() {
            TreasureBookModule.SetBackDetailState(BackDetailState.NONE)
            if(this.$refs.multiLineText.validate()) {
                this.$emit('confirm')
            }
        },
        updateDedication: function(newValue) {
            TreasureBookModule.SetDedication(newValue)
        },
        updateInternalDedication: function(newValue) {
            TreasureBookModule.SetBackDetailState(BackDetailState.TEXT)
            TreasureBookModule.SetUserInputDedication(newValue)
        },
        goToMenu: function() {
            if(this.confirmable) {
                this.onConfirm()
            }else {
                this.onCancel()
            }
        }
    },
    components: {
        PrimaryButtons, MultiLineTextEditor
    }
}
</script>

<style lang="scss">
#enter-dedication{

    .inputContainer{
        height: 367px;
        margin-bottom: 20px;

        #textarea-no-resize{
            max-width: 440px;
            height: 160px;
            line-height: 1.3;
            &:focus{
                box-shadow: 0 0 0 0.1rem rgba(0, 123, 255, 0.25);
            }
            &::placeholder{
                font-style: italic;
                text-align: left;
                
            }
        }
    
        @media (max-width: $rv-doubleTeaserBreakpoint) {
            height: fit-content;
        }
    }

}

</style>